import type { TOC } from '@ember/component/template-only';

import GenieSharedArtifactComponent from 'webapp/components/genie/shared-artifact/index';
import type { SharedArtifactModel } from 'webapp/routes/shared-artifact';

interface Args {
	model: SharedArtifactModel;
}

const SharedArtifactRouteTemplate: TOC<Args> = <template>
	<GenieSharedArtifactComponent @shareToken={{@model.shareToken}} />
</template>;

export default SharedArtifactRouteTemplate;
